import { LinearProgress } from './LinearProgress';
import { LinearProgressVariants, PasswordRequirementData, PasswordStrength } from './types';

const VARIANT_MAP = {
    [PasswordStrength.None]: 'error',
    [PasswordStrength.Weak]: 'error',
    [PasswordStrength.Normal]: 'warning',
    [PasswordStrength.Good]: 'success',
};

export interface PasswordInputStrengthProps {
    value?: string;
    requirements?: PasswordRequirementData[];
}

export const PasswordStatusBar = ({ value, requirements = [] }: PasswordInputStrengthProps) => {
    const passwordStrength = getPasswordStrength(requirements, value);

    return (
        <LinearProgress
            value={passwordStrength}
            max={PasswordStrength.Good}
            variant={VARIANT_MAP[passwordStrength] as LinearProgressVariants}
        />
    );
};

export function getPasswordStrength(
    validations: PasswordRequirementData[],
    password: string | undefined | null
): PasswordStrength {
    if (!password) {
        return PasswordStrength.None;
    }

    const validationChecks = validations.map(({ validate }) => validate(password));

    return Math.round((validationChecks.filter(Boolean).length / validationChecks.length) * PasswordStrength.Good);
}
